import React from 'react';

const Hero: React.FC = () => {
  return (
    <section id="hero" className="hero">
      <div className="container">
        <h1>
          Building Smarter{' '}
          <span className="highlight">
            Mobile Experiences.
          </span>
        </h1>
        
        <p>
          RapidNova develops innovative mobile applications that solve real-world problems 
          for everyday users. We create intuitive, meaningful apps that simplify daily tasks, 
          enhance productivity, and improve quality of life through thoughtful design and 
          cutting-edge technology.
        </p>
        
        <div className="hero-buttons">
          <a href="#about" className="btn-primary">
            Learn More
            <svg style={{ marginLeft: '8px', width: '20px', height: '20px' }} fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
            </svg>
          </a>
          <a href="#contact" className="btn-secondary">
            Get in Touch
          </a>
        </div>
      </div>
    </section>
  );
};

export default Hero; 